/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum CustomerUserItemAliases {
  ACTION_STATUS = 'action-status',
  AUTOCOMPLETE_LANGUAGE = 'autocomplete-language',
  AUTOCOMPLETE_LOCALE = 'autocomplete-locale',
  CONTEXTUAL_BAR_USER_ITEM = 'contextual-bar-user-item',
  FIELD_EMAIL_CONFIRMATION = 'field-email-confirmation',
  FIELD_ERMAIL = 'field-ermail',
  FIELD_LANGUAGE = 'field-language',
  FIELD_LOCALE = 'field-locale',
  FIELD_LOGIN = 'field-login',
  FIELD_USERNAME = 'field-username',
  FORM_USER = 'form-user',
  INPUT_EMAIL = 'input-email',
  INPUT_EMAIL_CONFIRMATION = 'input-email-confirmation',
  INPUT_LOGIN = 'input-login',
  INPUT_USERNAME = 'input-username',
  LAYOUT_USER_ITEM = 'layout-user-item',
  MAPPER_LANGUAGE = 'mapper-language',
  MAPPER_LOCALE = 'mapper-locale',
  PANEL_USER_ITEM = 'panel-user-item',
  TEXT_LANGUAGE = 'text-language',
  TEXT_LOCALE = 'text-locale',
}
export { CustomerUserItemAliases };
